import { type FunctionComponent } from 'react'

import useConsumptionTotal from 'src/hooks/composite/costs/useConsumptionTotal'

import { formatCurrency } from 'src/utils/format'

import moment from 'moment'
import { PiTrendDownBold, PiTrendUpBold } from 'react-icons/pi'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

// Define date ranges
// Define date ranges
const startOfThisMonth = moment().startOf('month')
const today = moment().startOf('day').subtract(1, 'day')

const startOfLastMonth = moment(startOfThisMonth).subtract(1, 'month')
const todayLastMonth = moment(today).subtract(1, 'month')

const mtdDateRange = [startOfThisMonth, today] as [moment.Moment, moment.Moment]
const lastMonthDateRange = [startOfLastMonth, todayLastMonth] as [moment.Moment, moment.Moment]

const AzureMonthToDateTile: FunctionComponent = () => {
  const navigate = useNavigate()

  // Get consumption data
  const mtdConsumptionTotal = useConsumptionTotal({ dateRange: mtdDateRange })
  const lastMonthConsumptionTotal = useConsumptionTotal({ dateRange: lastMonthDateRange })

  // Calculate change
  const percentChange =
    lastMonthConsumptionTotal && mtdConsumptionTotal && lastMonthConsumptionTotal !== 0
      ? Math.round(((mtdConsumptionTotal - lastMonthConsumptionTotal) / lastMonthConsumptionTotal) * 100)
      : 0

  const isIncrease = percentChange > 0
  const TrendIcon = isIncrease ? PiTrendUpBold : PiTrendDownBold
  const changeText = `(${isIncrease ? '+' : ''}${percentChange}%)`

  return (
    <Tile onMouseDown={() => navigate('/azure_overview')}>
      <TileHeader>
        <TileHeader.Title className="flex items-center gap-2">
          {mtdConsumptionTotal ? formatCurrency(Math.round(mtdConsumptionTotal)) : 'Loading...'}
          {percentChange !== 0 && <div className="mt-1 text-xs font-medium text-th-text-secondary">{changeText}</div>}
        </TileHeader.Title>
        <TileHeader.Subtitle>Azure Cost Month To Date</TileHeader.Subtitle>
        <TileHeader.Item>
          <TrendIcon className="h-10 w-10 text-th-primary" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default AzureMonthToDateTile
